import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import TimeButton from './TimeButton';
import getTimeCompletelyBooked from '../../api/ClientBookAppointment/getTimeCompletelyBooked.api';
import getRandomSalesAgent from '../../api/ClientBookAppointment/getRandomSalesAgent.api';
import { getBookedTime } from '../../redux/bookAppointment/actions';
import getSalesAgentAppointmentTime from '../../api/ClientBookAppointment/getSalesAgentAppointmentTime.api';
import { connect } from 'react-redux';
import styles from './BookAppointment.module.scss';

function DateSelector({
	appointmentDate,
	setAgentIdSelected,
	bookedTimeList,
	setSelectTime,
	selectTime,
	handleConfirm,
	setClickedTime,
	clickedTime,
	bookedTimes,
	setSalesAgentsChosen,
	setOpenDetailsForm,
	setConfirmedTime,
	// setDisabled,
}) {
	const [firstTime, setFirstTime] = useState();
	const [timeRange, setTimeRange] = useState([]);
	const [timeToBeDisabled, setTimeToBeDisabled] = useState();
	const [timeText, setTimeText] = useState();
	const [sameDayTime, setSameDayTime] = useState();

	useEffect(() => {
		var startTime = new Date(appointmentDate);
		let appointmentDay = dayjs(appointmentDate).format('D');
		let today = dayjs().format('D');

		if (appointmentDay === today) {
			let appointmentHr = dayjs(appointmentDate).format('H') * 1;
			if (appointmentHr < 13) {
				startTime.setHours(13, 0, 0);
			} else {
				let startHr = appointmentHr + 1;
				startTime.setHours(startHr, 0, 0);
			}
		} else {
			startTime.setHours(13, 0, 0);
		}
		setFirstTime(startTime);
		getBookedTime(new Date(appointmentDate).getTime());

		// getRandomSalesAgent(bookedTimes, (returned) =>
		// 	setSalesAgentsChosen(returned)
		// );
	}, [appointmentDate]);

	useEffect(() => {
		var timeRangeArr = [];
		var sameDayTimeArr = [];

		let hour = dayjs(firstTime).format('H') * 1;

		for (var i = 0; i < 20 - hour; i++) {
			var add = dayjs(firstTime).add(`${i * 60}`, 'minute');

			timeRangeArr.push(dayjs(add));

			sameDayTimeArr.push(parseInt('' + add));
		}

		setTimeRange(timeRangeArr);
		setSameDayTime(sameDayTimeArr);
	}, [firstTime]);

	// useEffect(() => {
	// 	if (bookedTimeList && appointmentDate && sameDayTime) {
	// 		const filteredArray = sameDayTime.filter((value) =>
	// 			bookedTimeList.includes(value)
	// 		);

	// 		console.log('bookedTimeList: ', bookedTimeList);

	// 		console.log('sameDayTime: ', sameDayTime);

	// 		console.log('filteredArray: ', filteredArray);

	// 		setTimeToBeDisabled(filteredArray);

	// 		console.log('includedd? ', bookedTimeList.includes(1621080000000));
	// 	}
	// }, [bookedTimeList, appointmentDate, sameDayTime]);

	return (
		<div className={styles.date_selector}>
			<h4>{dayjs(appointmentDate).format('ddd, MMM DD')}</h4>

			{sameDayTime?.map((time, index) => (
				<TimeButton
					key={index}
					time={time}
					timeToBeDisabled={bookedTimes}
					setClickedTime={setClickedTime}
					clickedTime={clickedTime}
					selectTime={selectTime}
					setSelectTime={setSelectTime}
					setTimeText={setTimeText}
					timeText={timeText}
					handleConfirm={handleConfirm}
					bookedTimeList={bookedTimeList}
					setOpenDetailsForm={setOpenDetailsForm}
					setConfirmedTime={setConfirmedTime}
					// setDisabled={setDisabled}
					setSalesAgentsChosen={setSalesAgentsChosen}
				/>
			))}
			{sameDayTime?.length === 0 && <span>No results found</span>}
		</div>
	);
}

const mapStateToProps = (state) => ({
	bookedTimes: state.bookAppointment.bookedTime,
});

export default connect(mapStateToProps)(DateSelector);
